export const SUPPORT_WARNINGS_FETCH = 'SUPPORT_WARNINGS_FETCH'
export const SUPPORT_WARNINGS_FETCH_RESPONSE = 'SUPPORT_WARNINGS_FETCH_RESPONSE'
